import { forwardRef } from 'react';
import { Button, message } from 'antd';
import SupplierListIcon from '../../../assets/SupplierListIcon.svg';
import editIcon from '../../../assets/editAdminIcon.svg';
import incumbent from '../../../assets/incumbent.svg';
import type { SupplierI } from '../../../pages/TenderViewPage/types';
import {
    annualPriceForSupplier,
    formatSupplierPriceZAR
} from '../../../utils/supplierPayloadPricing';
import './Evaluate4PendingTRSuppliersTaskComplete.scss';
import Edit from '../../Icons/Edit';
import copyImage from '../../../assets/copyImage.svg';

/** True when supplier has usable pricing (price_information or payload.price). */
const supplierHasPayloadPricing = (item: SupplierI): boolean => annualPriceForSupplier(item) != null;

const allSuppliersHavePricing = (suppliers: SupplierI[]): boolean =>
    suppliers.length > 0 && suppliers.every(supplierHasPayloadPricing);

export type Evaluate4PendingTRSuppliersTaskCompleteProps = {
    taskName: string | undefined;
    suppliers: SupplierI[];
    statusImage: (status: string) => string | undefined;
    setTaskId: (id: number) => void;
    setSupplierData: (data: {
        manager: { name: string; email: string; phone_number: string };
        company: { name: string };
        id: number;
    }) => void;
    setIsEditModal: (open: boolean) => void;
    onSpecifyPricing?: (supplier: SupplierI) => void;
    className?: string;
    status?: string;
};

export const Evaluate4PendingTRSuppliersTaskComplete = forwardRef<
    HTMLDivElement,
    Evaluate4PendingTRSuppliersTaskCompleteProps
>(function Evaluate4PendingTRSuppliersTaskComplete(
    {
        taskName,
        suppliers,

        statusImage,
        setTaskId,
        setSupplierData,
        status,
        setIsEditModal,
        onSpecifyPricing,
        className
    },
    ref
) {
    const rootClassName =
        className ??
        `tasks__task-complete task-complete${allSuppliersHavePricing(suppliers) ? ' green' : ''}`;

    const copyAllEmails = () => {
        const emailsArray: any = [];
        suppliers.forEach((elem) => {
            if (elem?.email) {
                emailsArray.push(elem.email);
            }
        });

        navigator.clipboard.writeText(emailsArray.join(' '));
        message.success('Supplier emails copied to clipboard successfully');
    };

    return (
        <div ref={ref} className={rootClassName}>
            <div className="task-complete__title">
                <div className="task-complete__title-row">
                    <img src={SupplierListIcon} />
                    {taskName}
                </div>
                <div className="task__copyemails" onClick={copyAllEmails}>
                    <img src={copyImage} />
                    Copy all Emails
                </div>
            </div>

            {suppliers.map((item) => {
                const annualPrice = annualPriceForSupplier(item);
                return (
                    <div className="task-complete__supplier supplier">
                        <div className="supplier__header with-switcher">
                            <div className="supplier-card__badge-wrapper">
                                {item?.added_by_buyer && <div className="supplier-card__added">Added by buyer</div>}
                                {item.incumbent && <div className="supplier-card__badge">Incumbent Supplier</div>}
                            </div>
                        </div>
                        <div className="supplier__row">
                            <div className="supplier__wrap first">
                                <div className="supplier__title">
                                    ({item.name_prefix}) {item.name}
                                </div>
                                <div className="supplier__subtitle">{item.trading_name}</div>
                            </div>
                            {item.manager_name ? (
                                <div className="supplier__wrap">
                                    <div className="supplier__title">{item.manager_name ? item.manager_name : ''}</div>
                                    <div className="supplier__subtitle">
                                        {item?.email ? item?.email : ''} {item?.phone_number ? item?.phone_number : ''}
                                    </div>
                                </div>
                            ) : (
                                <div className="supplier__wrap"></div>
                            )}

                            <img
                                src={editIcon}
                                className="supplier__delete"
                                onClick={() => {
                                    setTaskId(item.id);
                                    setSupplierData({
                                        manager: {
                                            name: item.manager_name,
                                            email: item.email,
                                            phone_number: item.phone_number
                                        },
                                        company: {
                                            name: item.name
                                        },
                                        id: item.id
                                    });
                                    setIsEditModal(true);
                                }}
                            />
                        </div>
                        {annualPrice == null ? (
                            <div className="evaluate4-pending-tr__specify-pricing-wrap">
                                <Button
                                    type="primary"
                                    className="blue-btn evaluate4-pending-tr__specify-pricing"
                                    onClick={() => onSpecifyPricing?.(item)}
                                >
                                    Specify Pricing
                                </Button>
                            </div>
                        ) : (
                            <div className="evaluate4-pending-tr__specify-pricing-wrap">
                                <div className="isIncumbent">
                                    <img src={incumbent} />
                                    Pricing Specified - {formatSupplierPriceZAR(annualPrice)}/year
                                    {status !== 'pending_su' && (
                                        <Edit
                                            fill="#001965"
                                            className="evaluate4-pending-tr__pricing-edit"
                                            onClick={() => onSpecifyPricing?.(item)}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
});
